import * as React from "react";

import { FormControlLabel, Radio, RadioProps } from "@material-ui/core";

import { useBranding } from "client/hooks";

export const ThemedRadio: React.FC<RadioProps> = ({
  checked,
  checkedIcon,
  inputProps,
  icon,
  name,
  onChange,
  value,
}) => {
  const { brandKey } = useBranding();
  const isCash = brandKey === "CashApp";

  const BronteRadio = (
    <Radio
      checked={checked}
      checkedIcon={checkedIcon}
      inputProps={inputProps}
      icon={icon}
      name={name}
      onChange={onChange}
      value={value}
    />
  );

  if (!isCash) return BronteRadio;

  const cashLabel = <CashLabel value={value as string} />;
  const cashRadio = (
    <Radio
      checked={checked}
      inputProps={inputProps}
      name={name}
      onChange={onChange}
      value={value}
    />
  );

  return <FormControlLabel control={cashRadio} label={cashLabel} />;
};

const CashLabel = ({ value }: { value: string }) => <span>{value}</span>;
